import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import axios from "axios";
import "./home.css";
import {
  AUTHORIZED_URL_PREFIX,
  SEARCH_URL,
  HOME_DATA_URL,
  LIBRARY_UNITS,
  UPDATE_SETTINGS_URL,
  AxiosConfig,
} from "../../Utils/Constants";
import Loading from "../common/Loading";
import { notify, pleaseRefreshError } from "../../Utils/Notificator";
import t from "../../Utils/Translation";
import Units from "./Units";
import FeaturedStory from "./FeaturedStory";
import FeaturedStories from "./FeaturedStories";
import { ErrorBoundary } from "react-error-boundary";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import HomeStats from "./HomeStats";
import ProfileBox from "../common/ProfileBox";
import EmptyCard from "../common/EmptyCard";
import UnitSplider from "../common/UnitSplider";
import FeaturedStoriesSplider from "../common/FeaturedStoriesSplider";
import first_screen from "./../../multimedia/first_screen.png";
import Form from "react-bootstrap/Form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Modal from "react-bootstrap/Modal";
import ProfileCard from "../common/ProfileCard";
import Story from "../stories/Story";
import RightFooter from "../common/RightFooter";
import LykioButton from "../common/LykioButton";
import Tooltip from "@mui/material/Tooltip";

const Home = () => {
  const context = useContext(LykioContext);
  const userDetails = context.userDetails;
  const tenantProperties = context.tenantProperties;
  const storiesName =
    tenantProperties && tenantProperties.storiesName
      ? tenantProperties.storiesName
      : "Stories";
  const tenantName =
    tenantProperties && tenantProperties.name ? tenantProperties.name : "Lykio";
  const initiative =
    tenantProperties &&
    tenantProperties.initiative &&
    tenantProperties.initiative;
  const makeHeadersDark = tenantProperties && tenantProperties.makeHeadersDark;
  const [featuredStories, setFeaturedStories] = useState([]);
  const [mostUsed, setMostUsed] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [newUnits, setNewUnits] = useState([]);
  const [numberOfGroups, setNumberOfGroups] = useState(0);
  const [numberOfActiveUsers, setNumberOfActiveUsers] = useState(0);
  const [numberOfActiveUnits, setNumberOfActiveUnits] = useState(0);
  const [numberOfApprovedStories, setNumberOfApprovedStories] = useState(0);
  const [enableSchools, setEnableSchools] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const language = localStorage.getItem("content-i18n");
  const navigate = useNavigate();


  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const { data } = await axios.post(
          `${AUTHORIZED_URL_PREFIX}${HOME_DATA_URL}`,
          { language },
          AxiosConfig()
        );
        setFeaturedStories(data.featuredStories);
        setMostUsed(data.mostUsed ? data.mostUsed : []);
        setNewUnits(data.newUnits ? data.newUnits : []);
        setTopRated(data.topRated ? data.topRated : []);
        setNumberOfGroups(data.numberOfGroups);
        setNumberOfActiveUsers(data.numberOfActiveUsers);
        setNumberOfActiveUnits(data.numberOfActiveUnits);
        setNumberOfApprovedStories(data.numberOfApprovedStories);
        setIsLoading(false);
        if (!data.success) {
          notify(pleaseRefreshError);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchHomeData();
  }, []);


  return (
    <div className="lykioccs-main-content lykiocss-home">
      {isLoading ? (
        <Loading />
      ) : (
        <React.Fragment>

          <Container style={{ marginLeft: "0em !important" }}>
          <Row style={{ margin: "0em", paddingLeft:'0em' }}>
          <p style={{ fontWeight: 'bold', color: 'white', fontSize: '4em' }}>
            Welcome back!
          </p>
          </Row>
            {/* <Row style={{ margin: "0em" }}>
              <HomeModal show={show} handleClose={handleClose}/>
              <Tooltip title={t("What effect does selection bias have on recruiters?")} placement="bottom">
                <LykioButton
                  style={{ width: "8em", marginTop: "1em" }}
                  id="showIntro"
                  variant="light"
                  onClick={() => handleShow()}
                >
                  Intro
                </LykioButton>
              </Tooltip>
            </Row> */}
            <Row>
              <Col xs={12}>
                <Row className="lykiocss-home-stats-wrapper">
                  {userDetails &&
                    userDetails.settings.dashboard.showProgress && (
                      <Col className="lykiocss-home-stats lykiocss-home-stats1 lykiocss-margin-top-half-em">
                        <EmptyCard>
                          <ProfileBox userDetails={userDetails} />
                        </EmptyCard>
                      </Col>
                    )}

                  {userDetails &&
                    userDetails.settings.dashboard.showProgress && (
                      <Col
                        onClick={() => {
                          navigate(`/profile/${userDetails && userDetails.id}`);
                        }}
                        className="lykiocss-home-stats lykiocss-home-stats2 lykiocss-margin-top-half-em"
                        style={{ cursor: "pointer" }}
                      >
                        <EmptyCard title={t(`Your Achievements`)}>
                          <ProfileBox userDetails={userDetails} />
                        </EmptyCard>
                      </Col>
                    )}

                  {userDetails &&
                    userDetails.settings.dashboard.showHomeStats && (
                      <Col className="lykiocss-home-stats lykiocss-home-stats3 lykiocss-margin-top-half-em">
                        <EmptyCard title={t("Platform at a glance")}>
                          <HomeStats
                            numberOfGroups={numberOfGroups}
                            numberOfActiveUsers={numberOfActiveUsers}
                            numberOfActiveUnits={4}
                            numberOfApprovedStories={numberOfApprovedStories}
                          />
                        </EmptyCard>
                      </Col>
                    )}
                </Row>
              </Col>
            </Row>
          </Container>

          {featuredStories.length > 0 &&
            userDetails &&
            userDetails.settings.dashboard.showFeatured && (
              <div style={{ marginTop: "1em", marginLeft: "1em" }}>
                <Units
                  title={`${t("Featured News")}`}
                  units={featuredStories}
                  makeHeadersDark={makeHeadersDark}
                />
              </div>
            )}
        </React.Fragment>
      )}
      <RightFooter />
    </div>
  );
};


// const HomeModal = (props)=>{

//   const show = props.show;
//   const handleClose = props.handleClose;

//   return <Modal
//   centered
//   size="lg"
//   show={show} onHide={handleClose}
// >
//   <Modal.Header closeButton>
//   </Modal.Header>
//   <Modal.Body>
//   <div style={{ minWidth: "20em", minHeight: "25em", marginLeft:'1em', marginRight:'1em' }}>
//       <p>{t('Welcome!')}</p>
//       <p>
//         {t("Having preferences and harboring prejudices is part of human nature and inevitably conditions our choices. We are bombarded every second by at least eleven million pieces of information from the outside world, but our own brains can only consciously process one out of every forty. To manage this limit, our brains create shortcuts that give meaning to information: heuristics or cognitive biases.")} 
//         <b>{t("A bias is a prejudice that distances a person from a correct and objective judgment.")}</b>
//         {t("When we select people, these biases can forcefully enter the evaluation process and influence decision making. For this reason, it is important that professionals in human resources promote diversity in every area, guarantee absolute transparency and impartiality, and make their choices solely on the basis of merit and the value of the candidate, already in the recruiting phase.")}
//       </p>
//       <p>{t("In this course, you'll have the chance to...")}</p>
//       <ul style={{fontWeight:'300'}}>
//         <li>{t("Dialogue with avatars to train the ability to ask bias-free questions")}</li>
//         <li>{t("Comparative evaluation of multiple candidates to train the ability to evaluate without bias")}</li>
//         <li>{t("Observing a fragment of a selection interview with the aim of identifying biases that influence the evaluator's performance")}</li>
//         <li>{t("Riddles and games on cognitive biases and distortions")}</li>
//         <li>{t("Comparative analysis of CVs through blind screening to highlight bias risks")}</li>
//       </ul>
//       <div className="lykiocss-center">
//       <video controls className="lykiocss-center" src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/assets/the-approach.mp4" 
//       style={{borderRadius:'15px', maxWidth: '36em'}}></video>
//       </div>
//     </div>
//   </Modal.Body>
// </Modal>
// }


export default Home;
